import React from "react";
import { formatPrice } from "../utils/format";

const CartItem = ({ item, price, onUpdateQuantity, onRemove }) => (
    <div className="pc-cart-item">
        <div className="pc-cart-item-top">
            <div className="pc-cart-item-name">{item.name}</div>
            <button className="pc-cart-remove" onClick={onRemove} title="Удалить" aria-label="Удалить">✕</button>
        </div>
        <div className="pc-cart-item-meta">{item.source} · {item.manufacturer}</div>
        <div className="pc-cart-item-row">
            <input
                className="pc-qty-input"
                type="number"
                min={1}
                value={item.quantity}
                onChange={(e) => onUpdateQuantity(e.target.value)}
            />
            <span>× {formatPrice(price)} ₽ = {formatPrice(price * item.quantity)} ₽</span>
        </div>
    </div>
);

export default CartItem;
